var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',_vm._b({staticStyle:{"width":"100%"},attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}},'el-select',_vm.$attrs,false),_vm._l((_vm.options),function(item,index){return _c('el-option',{key:index,attrs:{"value":_vm.options[index].value,"label":index}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619b55a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/support/components/DySelect.vue
// module id = null
// module chunks = 